module.exports = __webpack_public_path__ + "static/mr-online-program-music-world-wide-2-98337c5e37cae86c22f04579bb58aea4.jpg";